/**
 * Ajudantes de desenho em SVG usados pelos gráficos: barra com ponta
 * arredondada, escala, marcas do eixo e quebra de texto em linhas.
 *
 * Lê: nada.
 * Usado por: graficos/*.tsx.
 */

export const FONTE = 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

export function limitar(valor: number, minimo: number, maximo: number): number {
  return Math.min(maximo, Math.max(minimo, valor));
}

/** Barra horizontal: ponta da direita arredondada, base (esquerda) reta. */
export function caminhoBarra(x: number, y: number, largura: number, altura: number, raio = 4): string {
  if (largura <= 0) return '';
  const r = Math.min(raio, largura, altura / 2);
  const fim = x + largura;
  return `M${x},${y} H${fim - r} Q${fim},${y} ${fim},${y + r} V${y + altura - r} Q${fim},${y + altura} ${fim - r},${y + altura} H${x} Z`;
}

/** Arredonda para cima até o próximo múltiplo do passo: (0,223; 0,05) → 0,25. */
export function arredondarPara(valor: number, passo: number): number {
  return Math.ceil((valor - 1e-9) / passo) * passo;
}

/** 0, passo, 2×passo... até o máximo. */
export function marcasDoEixo(maximo: number, passo: number): number[] {
  const marcas: number[] = [];
  for (let valor = 0; valor <= maximo + 1e-9; valor += passo) marcas.push(Math.round(valor * 1e6) / 1e6);
  return marcas;
}

/** Escolhe um passo de eixo "redondo" para frações (5%, 10%, 25%...). */
export function passoDoEixo(maximo: number): number {
  if (maximo <= 0.3) return 0.05;
  if (maximo <= 0.6) return 0.1;
  return 0.25;
}

/** Quebra um texto em linhas que caibam na largura (estimativa pelo tamanho da fonte). */
export function quebrarTexto(texto: string, largura: number, tamanhoFonte: number): string[] {
  const maximo = Math.max(10, Math.floor(largura / (tamanhoFonte * 0.55)));
  const linhas: string[] = [];
  let atual = '';
  for (const palavra of texto.split(/\s+/)) {
    if (atual === '') atual = palavra;
    else if ((atual + ' ' + palavra).length <= maximo) atual += ' ' + palavra;
    else {
      linhas.push(atual);
      atual = palavra;
    }
  }
  if (atual) linhas.push(atual);
  return linhas;
}

/** Encurta um nome para caber na largura: "Guilherme Cavalieri" → "G. Cavalieri". */
export function abreviarNome(nome: string, larguraMaxima: number, tamanhoFonte: number): string {
  const cabem = Math.floor(larguraMaxima / (tamanhoFonte * 0.58));
  if (nome.length <= cabem) return nome;
  const partes = nome.split(' ').filter(Boolean);
  if (partes.length > 1) {
    const inicial = `${partes[0]?.charAt(0) ?? ''}.`;
    const opcoes = [`${inicial} ${partes.slice(1).join(' ')}`, `${inicial} ${partes[partes.length - 1] ?? ''}`];
    const cabe = opcoes.find((opcao) => opcao.length <= cabem);
    if (cabe) return cabe;
  }
  return `${nome.slice(0, Math.max(1, cabem - 1))}…`;
}
